import React from 'react';
import {Container, TableFooter} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {round} from "../Util";
import styles from '../styles/controls/ArticleSentimentStatsTable.module.css';
import * as _ from 'lodash';

export interface ArticleSentimentStatsRow {
  siteUrl: string,
  fullUrl: string,
  totalNumberOfPoints: number,
  totalAverageSentiment: number,
  keywordNumberOfPoints: number,
  keywordAverageSentiment: number
}

export interface ArticleSentimentStatsProps {
  rows: ArticleSentimentStatsRow[],
  showTotal: boolean
}

const ArticleSentimentStatsTable: React.FC<ArticleSentimentStatsProps> = (props: ArticleSentimentStatsProps) => {

  const percentChange = (oldValue: number, newValue: number): number => {
    if (oldValue === 0) {
      return 0
    }
    return (newValue - oldValue) / oldValue
  }

  const sentimentPercentChange = (row: ArticleSentimentStatsRow): number => {
    return percentChange(row.totalAverageSentiment, row.keywordAverageSentiment)
  }

  const formatPercentValue = (a: number): number => {
    return round(100 * a, 2)
  }

  const formatDoubleValue = (a: number): number => {
    return round(a, 4)
  }

  return (
    props.rows.length === 0 ? null : (
      <Container maxWidth='xl' hidden={props.rows.length === 0}>
        <Table className={styles.table} aria-label="simple table">
          <TableHead className={styles.tableHeader}>
            <TableRow>
              <TableCell>Site</TableCell>
              <TableCell align="right">Total number of points</TableCell>
              <TableCell align="right">Points by keyword</TableCell>
              <TableCell align="right">Average sentiment</TableCell>
              <TableCell align="right">Average sentiment by keyword</TableCell>
              <TableCell align="right">Percent change</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows.map((row) => (
              <TableRow key={row.siteUrl}>
                <TableCell component="th" scope="row">
                  <a href={row.siteUrl}>{row.fullUrl}</a>
                </TableCell>
                <TableCell align="right">{row.totalNumberOfPoints}</TableCell>
                <TableCell align="right">{row.keywordNumberOfPoints}</TableCell>
                <TableCell
                  align="right">{formatDoubleValue(row.totalAverageSentiment)}
                </TableCell>
                <TableCell
                  align="right">{formatDoubleValue(row.keywordAverageSentiment)}
                </TableCell>
                <TableCell
                  align="right">{formatPercentValue(sentimentPercentChange(row))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          {props.showTotal &&
          <TableFooter>
              <TableRow>
                  <TableCell component="th" scope="row">Total</TableCell>
                  <TableCell
                      align="right">{_.sumBy(props.rows, o => o.totalNumberOfPoints)}</TableCell>
                  <TableCell
                      align="right">{_.sumBy(props.rows, o => o.keywordNumberOfPoints)}</TableCell>
                  <TableCell
                      align="right">{formatDoubleValue(_.meanBy(props.rows, o => o.totalAverageSentiment))}</TableCell>
                  <TableCell
                      align="right">{formatDoubleValue(_.meanBy(props.rows, o => o.keywordAverageSentiment))}</TableCell>
                  <TableCell
                      align="right">{formatPercentValue(_.mean(_.map(props.rows, r => sentimentPercentChange(r))))}</TableCell>
              </TableRow>
          </TableFooter>
          }
        </Table>
      </Container>
    )
  )
}

export default ArticleSentimentStatsTable
